import z from "zod";

export const deleteCalculationMemberParamSchema = z.object({
	calculationId: z.uuid(),
	userId: z.string().min(1),
});

export type DeleteCalculationMemberParamSchema = z.infer<typeof deleteCalculationMemberParamSchema>;
